var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDrive = function SvgDrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 43,
    fill: "none",
    viewBox: "0 0 40 43"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2264_200045)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5F6F8",
    stroke: "#fff",
    strokeWidth: 1.427,
    d: "m21.014 3.087 12.16 7.04a2.77 2.77 0 0 1 1.382 2.398v14.08c0 .99-.527 1.904-1.381 2.399l-12.161 7.04a2.75 2.75 0 0 1-2.759 0l-12.161-7.04a2.77 2.77 0 0 1-1.38-2.399v-14.08c0-.99.526-1.904 1.38-2.398l12.161-7.04a2.75 2.75 0 0 1 2.759 0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2264_200045)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066DA",
    d: "m13.21 24.252.705 1.219c.147.257.358.458.605.605l2.52-4.362H12c0 .284.073.568.22.825z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00AC47",
    d: "m20 16.583-2.52-4.362a1.66 1.66 0 0 0-.605.604L12.22 20.89a1.66 1.66 0 0 0-.22.824h5.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M25.48 26.076c.247-.147.458-.348.605-.605l.293-.504 1.402-2.428c.147-.257.22-.541.22-.825h-5.04l1.072 2.108z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832D",
    d: "m20 16.582 2.52-4.362a1.6 1.6 0 0 0-.825-.22h-3.39c-.293 0-.578.082-.825.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684FC",
    d: "M22.96 21.714h-5.92l-2.52 4.362c.247.146.532.22.825.22h9.31c.293 0 .578-.083.825-.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA00",
    d: "m25.453 16.858-2.328-4.033a1.66 1.66 0 0 0-.605-.604L20 16.583l2.96 5.131h5.03a1.66 1.66 0 0 0-.22-.824z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2264_200045"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 12h16v14.296H12z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2264_200045",
    width: 38.83,
    height: 42.685,
    x: 0.219,
    y: 0.113,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.89
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.89
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2264_200045"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2264_200045",
    result: "shape"
  })))));
};
export default SvgDrive;